<template>
  <b-tabs ref="tabs">
    <b-tab
      v-if="!permissions || permissions.readMessages"
      id="messages"
      class="p-2"
      @click="messages = 0">
      <template slot="title">
        <div style="position: relative;">
          <i class='fa fa-fw fa-comment'></i>
          <b-badge v-if="messages" pill variant="danger" style="position: absolute; top: 0.7em; left: 0.7em;">
            {{ messages }}
          </b-badge>
        </div>
      </template>
      <messages
        :context="context"
        :context-id="contextId"
        :disabled="permissions && !permissions.sendMessages"
        @message="onMessage"
      ></messages>
    </b-tab>

    <b-tab
      v-if="!permissions || permissions.viewFiles"
      id="files"
      class="p-2"
      @click="files = 0">
      <template slot="title">
        <div style="position: relative;">
          <i class='fa fa-fw fa-cloud'></i>
          <b-badge v-if="files" pill variant="danger" style="position: absolute; top: 0.7em; left: 0.7em;">
            {{ files }}
          </b-badge>
        </div>
      </template>
      <files
        :context="context"
        :context-id="contextId"
        :workgroup-id="workgroupId"
        :disabled="permissions && !permissions.uploadFiles"
        :permissions="permissions"
        @file="onFile"
      ></files>
    </b-tab>

    <template #tabs-end>
     <b-nav-item class="ml-auto" role="presentation" href="" @click.prevent="$emit('close')">
       <i class='fa fa-fw fa-times'></i>
     </b-nav-item>
   </template>
  </b-tabs>
</template>
<script>
export default {
  name: 'DefaultAside',

  props: {
    context: {
      type: String,
      required: true
    },

    contextId: {
      type: [String, Number],
      required: true
    },

    workgroupId: {
      type: Number,
      required: true,
    },

    permissions: {
      type: Object,
      default: undefined
    }
  },

  data() {
    return {
      messages: 0,
      files: 0,
    };
  },

  methods: {
    getSelectedTab() {
      if (!this.$refs.tabs) {
        return undefined;
      }

      const tabs = this.$refs.tabs.getTabs();
      const index = this.$refs.tabs.currentTab;

      console.log("TABS", index, tabs, this.$refs.tabs);

      if (tabs && index < tabs.length) {
        return tabs[index].id;
      }

      return undefined;
    },

    onMessage(m) {
      if (this.getSelectedTab() !== 'messages') {
        this.messages++;
      }
      this.$emit('message', m);
    },

    onFile(f) {
      if (this.getSelectedTab() !== 'files') {
        this.files++;
      }
      this.$emit('file', f);
    },
  }
}
</script>
